import _ from "lodash";

import { getInfections } from "../root.selectors";

export const getInfectionList = _.flow(
  getInfections,
  infectionsSlice => infectionsSlice.list
);
